import React, { useEffect, useMemo, useState } from 'react'
import { useLocation, useNavigate, useOutletContext, useSearchParams } from 'react-router-dom'
import { getThemeById } from '../../config/themes'
import ModernLotteryResultSections from '../../components/lottery-result/ModernLotteryResultSections'
import { lotteryService, type LotteryRound } from '../../services/lotteryService'
import { isYeekeeRound } from '../../utils/lotteryResultSectionUtils'
import type { LobbyHuayOutletContext } from './ModernLobbyHuayLayout'

const IMG_PLACEHOLDER = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'

function todayBangkokYYYYMMDD(): string {
  const f = new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Bangkok',
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
  })
  return f.format(new Date())
}

/** หน้า ผลหวย — ใช้ ModernLotteryResultSections ร่วมกับ หน้าแรก */
const ModernLobbyHuayResultPage: React.FC = () => {
  const { themeConfig, assetConfig } = useOutletContext<LobbyHuayOutletContext>()
  const [searchParams] = useSearchParams()
  const location = useLocation()
  const navigate = useNavigate()
  const targetRoundId = searchParams.get('roundId') || null

  const [selectedDate, setSelectedDate] = useState(todayBangkokYYYYMMDD)

  useEffect(() => {
    if (!targetRoundId) return
    const stateRound = (location.state as { round?: LotteryRound } | null)?.round
    if (stateRound && isYeekeeRound(stateRound)) {
      navigate(`/lobby-huay/yeekee/result?roundId=${targetRoundId}`, { state: { round: stateRound }, replace: true })
      return
    }
    if (stateRound) return
    let cancelled = false
    lotteryService.getRoundById(targetRoundId).then((round) => {
      if (!cancelled && round && isYeekeeRound(round)) {
        navigate(`/lobby-huay/yeekee/result?roundId=${targetRoundId}`, { state: { round }, replace: true })
      }
    })
    return () => {
      cancelled = true
    }
  }, [targetRoundId, location.state, navigate])

  const themeFolder = useMemo(
    () => getThemeById(themeConfig.themeId)?.folder ?? 'HuayToday-Blue',
    [themeConfig.themeId]
  )
  const getAssetUrl = (path: string) => {
    const base = assetConfig.CDN_BASE_URL ? `${assetConfig.CDN_BASE_URL}/${themeFolder}` : `/${themeFolder}`
    return base + (path.startsWith('/') ? path : `/${path}`)
  }
  const handleImgError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    const el = e.currentTarget
    if (el.dataset.imgFallback === '1') return
    el.dataset.imgFallback = '1'
    el.src = IMG_PLACEHOLDER
  }

  return (
    <>
      <ModernLotteryResultSections
        tenantId={themeConfig.tenantId}
        selectedDate={selectedDate}
        onSelectedDateChange={setSelectedDate}
        showDatePicker
        showTitle
        getAssetUrl={getAssetUrl}
        handleImgError={handleImgError}
        targetRoundId={targetRoundId}
        showPoolError
        onYeekeeRoundClick={(r: LotteryRound) =>
          navigate(`/lobby-huay/yeekee/result?roundId=${r._id}`, { state: { round: r } })
        }
        wipWupMinutes={themeConfig.settings?.wipWupMinutes}
        className="row mx__1 lottery-result-lobby"
      />
    </>
  )
}

export default ModernLobbyHuayResultPage
